// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"47":"46bfb103","242":"9030ec40","309":"ae95e2e8","388":"a27f1cbd","628":"636e05d3","791":"51ad1cc5"}[chunkId] + ".chunk.js";
};